import { useCallback } from 'react';

import { useNotification } from '../../../contexts/NotificationContext';
import { useDeleteChatDeliverySettingMutation } from '../../../generated';

interface UseDeleteDeliverySettingConfig {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useDeleteDeliverySetting = ({
  onSuccess,
  onError,
}: UseDeleteDeliverySettingConfig = {}) => {
  const { addNotification } = useNotification();
  const [deleteDeliverySetting, { loading }] =
    useDeleteChatDeliverySettingMutation();

  const deleteSettings = useCallback(
    async (chatId: string) => {
      try {
        await deleteDeliverySetting({ variables: { chatId } });

        addNotification({
          title: 'Success',
          message: 'Delivery settings removed — using company defaults',
          type: 'success',
        });

        onSuccess?.();
      } catch (error) {
        addNotification({
          title: 'Error',
          message: 'Failed to remove delivery settings',
          type: 'error',
        });
        onError?.(error as Error);
      }
    },
    [deleteDeliverySetting, addNotification, onSuccess, onError]
  );

  return {
    deleteSettings,
    isDeleting: loading,
  };
};
